import { motion } from "framer-motion";
import { Sparkles, Brain, Radio, Users, CheckCircle2 } from "lucide-react";

const STAGES = {
  Monitoring: { icon: Radio, color: "#C4B5FD", text: "Monitoring" },
  Thinking: { icon: Brain, color: "#C4B5FD", text: "Thinking" },
  Coordinating: { icon: Radio, color: "#F97316", text: "Coordinating" },
  "Responders Assigned": { icon: Users, color: "#F97316", text: "Responders Assigned" },
  Resolved: { icon: CheckCircle2, color: "#16A34A", text: "Resolved" },
};

export const GuardianPanel = ({ status = "Thinking" }) => {
  const s = STAGES[status] || STAGES.Thinking;
  const Icon = s.icon;
  const order = ["Monitoring", "Thinking", "Coordinating", "Responders Assigned", "Resolved"];
  const idx = order.indexOf(status);
  return (
    <div className="rounded-3xl p-5 bg-[#111827] text-white relative overflow-hidden shadow-lg" data-testid="guardian-panel">
      <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full" style={{ background: `${s.color}33`, filter: "blur(30px)" }} />
      <div className="flex items-center gap-3 relative">
        <div className="relative">
          <motion.span className="absolute -inset-2 rounded-2xl" style={{ background: `${s.color}55` }}
            animate={{ opacity: [0.4, 0.9, 0.4], scale: [0.95, 1.05, 0.95] }} transition={{ duration: 2, repeat: Infinity }} />
          <div className="relative w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: s.color }}>
            <Icon className="w-6 h-6 text-[#111827]" />
          </div>
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#C4B5FD]"><Sparkles className="w-3.5 h-3.5" /> Guardian AI</div>
          <p className="text-xl font-bold font-head" data-testid="guardian-status">{s.text}</p>
        </div>
      </div>
      <div className="flex gap-1.5 mt-4 relative">
        {order.map((o, i) => (
          <div key={o} className="h-1.5 flex-1 rounded-full overflow-hidden bg-white/15">
            <motion.div className="h-full rounded-full" style={{ background: i <= idx ? s.color : "transparent" }}
              initial={{ width: 0 }} animate={{ width: i <= idx ? "100%" : 0 }} transition={{ duration: 0.5 }} />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-white/50 mt-3 relative">Guardian AI coordinates your trusted circle. It is not connected to official emergency services.</p>
    </div>
  );
};
